module.exports = __webpack_public_path__ + "img/backspace.7f634465.svg";